import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Navigation from '@segment/templates/Navigation'
import FooterCompact from '@segment/templates/FooterCompact'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import GettingStarted from './components/GettingStarted'
import KeyFindings from './components/KeyFindings'
import Methodology from './components/Methodology'
import PersonalizationAroundTheGlobe from './components/PersonalizationAroundTheGlobe'
import RecommendedReading from './components/RecommendedReading'

import ogImagePng from './assets/OgStateOfPersonalizationReport2022.png'

const StateOfPersonalizationReport2022 = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="2022 State of Personalization Report | Twilio Segment"
        pageDescription="The State of Personalization report looks at how attitudes, preferences, and experiences with personalization have evolved over the past year. This report features survey data from 3,000+ businesses and consumers worldwide to explore expectations for digital experiences, data privacy, personalization, and more."
        pageOG={ogImagePng}
      >
        <Navigation />
        <Hero />
        <Main>
          <PersonalizationAroundTheGlobe />
          <KeyFindings />
          <Methodology />
          <Gray>
            <RecommendedReading />
            <GettingStarted />
          </Gray>
        </Main>
      </Layout>
      <FooterCompact />
    </AppearanceProvider>
  )
}

const Main = styled.main``

const Gray = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default StateOfPersonalizationReport2022
